import { helpers, cartManager } from "@/utilities";
export default {
  name: "coupon mixin",
  methods: {
    onSubmitAutoCoupon() {
      let self = this;
      cartManager.generateCouponObject(this.cart).then((coupon) => {
        cartManager
          .postVerifyCoupon(coupon)
          .then((result) => {
            if (result.coupon) {
              this.cart.coupon_result = result;
              cartManager.setCart(this.cart, true, true);
              self.$notify({
                group: "bottomRight",
                title: this.$t('message.coupon_notify_title'),
                type: "success",
                text: this.$t('message.autocoupon_notify_message', { coupon_name: this.cart.coupon })
              });
            }
          })
          .catch((e) => {
            this.captureException(e)
          });
      });
    },

    onSubmitCoupon(autoCoupon, showNotification = false) {

      return new Promise((resolve) => {
        if (this.user && this.cart.coupon && this.cart.order.length) {
          let self = this;
          cartManager.generateCouponObject(this.cart).then((coupon) => {
            cartManager
              .postVerifyCoupon(coupon)
              .then((result) => {
                if (result.coupon) {
                  this.cart.coupon_result = result;
                  this.cart.coupon_error = null;
                  if (showNotification) {
                    self.$notify({
                      group: "bottomRight",
                      title: this.$t("message.coupon_notify_title"),
                      type: "success",
                      text: this.$t("message.coupon_notify_message", {
                        coupon_name: this.cart.coupon,
                      }),
                    });
                  }
                  cartManager.setCart(this.cart, true, false);
                  resolve({ valid: true, auto: autoCoupon });
                } else {
                  this.cart.coupon_result = null;
                  this.cart.coupon_error = result;
                  cartManager.setCart(this.cart, true, false);
                  this.$root.$emit("REFRESH_CART_DATA");
                  //-- display a message that the provided error only if it's not an auto-coupon
                  this.$nextTick(() => {
                    if (autoCoupon) {
                      cartManager.setCart(this.cart, true, false);
                      resolve({ valid: true, auto: autoCoupon });
                    } else {
                      //--> is not autoCoupon
                      if (showNotification) {
                        self.$notify({
                          group: "bottomRight",
                          title: this.$t("message.coupon_not_valid_notify_title"),
                          type: "danger",
                          text:
                            result.error && result.error.message
                              ? result.error.message
                              : this.$t(
                                "message.coupon_not_valid_notify_message",
                                { coupon_name: this.cart.coupon }
                              ),
                        });
                      }

                      //--- apply the auto-coupon if any
                      if (!this.cart.coupon_result) {
                        let autoCouponFound = helpers.checkforAutoCoupon(
                          this.selectedLocation
                        );
                        this.cart.coupon = autoCouponFound
                          ? autoCouponFound.code
                          : "";
                        if (this.cart.coupon.length) {
                          resolve(this.onSubmitCoupon(true));
                        } else {
                          resolve({ valid: false, auto: autoCoupon });
                        }
                      }
                    }
                  });
                }
              })
              .catch((e) => {
                this.cart.coupon_result = null;
                this.cart.coupon_error = e.data;
                self.$notify({
                  group: "bottomRight",
                  title: this.$t("message.coupon_not_valid_notify_title"),
                  type: "danger",
                  text: e.data?.errors && e.data?.errors?.coupon?.length ? e.data.errors.coupon[0] : e.data.message,
                });
                cartManager.setCart(this.cart, true, false);
                this.$root.$emit("REFRESH_CART_DATA");
                this.$nextTick(() => {
                  if (autoCoupon) {
                    cartManager.setCart(this.cart, true, false);
                    resolve({ valid: true, auto: autoCoupon });
                  }
                  //--- apply the auto-coupon if any
                  if (!this.cart.coupon_result) {
                    let autoCouponFound = helpers.checkforAutoCoupon(
                      this.selectedLocation
                    );
                    this.cart.coupon = autoCouponFound
                      ? autoCouponFound.code
                      : "";
                    if (this.cart.coupon.length) {
                      resolve(this.onSubmitCoupon(true, false));
                    } else {
                      resolve({ valid: false, auto: autoCoupon });
                    }
                  }
                });
              });
          });
        } else {
          resolve({ valid: true, auto: autoCoupon });
        }
      });
    },
  }
}